/**
 * These are duplicate, JavaScript definitions of colors found in ./colors.css, added when we need to refer to
 * colors directly in JavaScript.  When possible, prefer css color strings over these variables.
 * see the documentation header in ./color.css for more information on choosing/adding colors.
 *
 */
const generateDeprecatedTheme = () => {
  const colorPrimaryBlueValues = [0, 73, 120] as const;
  const colorPrimaryGreenValues = [199, 219, 76] as const;
  const colorSecondaryBlueValues = [30, 130, 204] as const;
  const colorSecondaryDarkBlueValues = [3, 31, 52] as const;
  const colorSecondaryDarkGrayValues = [89, 90, 90] as const;
  const colorSecondaryLightBlueValues = [75, 163, 229] as const;
  const colorSecondaryLightGrayValues = [105, 121, 130] as const;
  const colorPrimaryBlueValuesOther = [31, 68, 97] as const;

  return {
    colorPrimaryBlueValues,
    colorPrimaryGreenValues,
    colorSecondaryBlueValues,
    colorSecondaryDarkBlueValues,
    colorSecondaryDarkGrayValues,
    colorSecondaryLightBlueValues,
    colorSecondaryLightGrayValues,
    colorPrimaryBlueValuesOther,
    colorPrimaryBlue: `rgb(${colorPrimaryBlueValues.join(',')})` as const,
    colorPrimaryGreen: `rgb(${colorPrimaryGreenValues.join(',')})` as const,
    colorSecondaryBlue: `rgb(${colorSecondaryBlueValues.join(',')})` as const,
    colorSecondaryDarkBlue: `rgb(${colorSecondaryDarkBlueValues.join(',')})` as const,
    colorSecondaryDarkGray: `rgb(${colorSecondaryDarkGrayValues.join(',')})` as const,
    colorSecondaryLightBlue: `rgb(${colorSecondaryLightBlueValues.join(',')})` as const,
    colorSecondaryLightGray: `rgb(${colorSecondaryLightGrayValues.join(',')})` as const,
  } as const;
};

export const THEME_OLD = generateDeprecatedTheme();

export const THEME_LIGHT = (()=> {
  const colorPrimaryPurpleValue = 274 as const;
  const colorPrimaryPinkValue = 319 as const;
  const colorPrimaryGreenValue = 157 as const;
  const colorSecondaryGrayValues = [105, 121, 130] as const;
  colorSecondaryGrayValues;

  return {
    colorPrimaryPurpleValue,
    colorPrimaryPinkValue,
    colorSecondaryGrayValues,
    colorPrimaryPurple: `hsl(${colorPrimaryPurpleValue} 100% 49%)` as const,
    colorPrimaryPink: `hsl(${colorPrimaryPurpleValue} 71% 51%)` as const,
    colorPrimaryGreen: `hsl(${colorPrimaryGreenValue} 72% 42%)` as const,
    colorSecondaryGray: `rgb(${colorSecondaryGrayValues.join(',')})` as const,
    colorNavLink1: 'hsl(274deg 100% 69%)' as const,
    deprecated: {
      ...generateDeprecatedTheme(),
    },
  };
})();

export const colorPrimaryBlueValues = [0, 73, 120];
export const colorPrimaryGreenValues = [199, 219, 76];
export const colorSecondaryBlueValues = [30, 130, 204];
export const colorSecondaryDarkBlueValues = [3, 31, 52];
export const colorSecondaryDarkGrayValues = [89, 90, 90];
export const colorSecondaryLightBlueValues = [75, 163, 229];
export const colorSecondaryLightGrayValues = [105, 121, 130];
export const colorPrimaryBlueValuesOther = [31, 68, 97];

export const colorPrimaryBlue = `rgb(${colorPrimaryBlueValues.join(',')})`;
export const colorPrimaryGreen = `rgb(${colorPrimaryGreenValues.join(',')})`;
export const colorSecondaryBlue = `rgb(${colorSecondaryBlueValues.join(',')})`;
export const colorSecondaryDarkBlue = `rgb(${colorSecondaryDarkBlueValues.join(',')})`;
export const colorSecondaryDarkGray = `rgb(${colorSecondaryDarkGrayValues.join(',')})`;
export const colorSecondaryLightBlue = `rgb(${colorSecondaryLightBlueValues.join(',')})`;
export const colorSecondaryLightGray = `rgb(${colorSecondaryLightGrayValues.join(',')})`;


export const COLOR_EXTRACTED_VALUES_0 = [0, 0, 0]; // '#000';
export const COLOR_EXTRACTED_VALUES_1 = [0, 0, 153]; // '#009';
export const COLOR_EXTRACTED_VALUES_2 = [0, 0, 238]; // '#00e';
export const COLOR_EXTRACTED_VALUES_3 = [0, 112, 243]; // '#0070f3';
export const COLOR_EXTRACTED_VALUES_4 = [0, 73, 120]; // '#004978';
export const COLOR_EXTRACTED_VALUES_5 = [102, 102, 102]; // '#666';
export const COLOR_EXTRACTED_VALUES_6 = [105, 32, 125]; // '#69207d';
export const COLOR_EXTRACTED_VALUES_7 = [108, 117, 125]; // '#6c757d';
export const COLOR_EXTRACTED_VALUES_8 = [133, 100, 4]; // '#856404';
export const COLOR_EXTRACTED_VALUES_9 = [133, 92, 20]; // '#855c14';
export const COLOR_EXTRACTED_VALUES_10 = [140, 3, 252]; // '#8c03fc';
export const COLOR_EXTRACTED_VALUES_11 = [141, 158, 168]; // '#8d9ea8';
export const COLOR_EXTRACTED_VALUES_12 = [148, 207, 88]; // '#94cf58';
export const COLOR_EXTRACTED_VALUES_13 = [151, 233, 236]; // '#97e9ec';
export const COLOR_EXTRACTED_VALUES_14 = [160, 160, 160]; // '#a0a0a0';
export const COLOR_EXTRACTED_VALUES_15 = [179, 197, 68]; // '#b3c544';
export const COLOR_EXTRACTED_VALUES_16 = [180, 76, 76]; // '#b44c4c';
export const COLOR_EXTRACTED_VALUES_17 = [182, 82, 0]; // '#b65200';
export const COLOR_EXTRACTED_VALUES_18 = [188, 243, 57]; // '#bcf339';
export const COLOR_EXTRACTED_VALUES_19 = [189, 156, 25]; // '#bd9c19';
export const COLOR_EXTRACTED_VALUES_20 = [190, 86, 86]; // '#be5656';
export const COLOR_EXTRACTED_VALUES_21 = [192, 190, 190]; // '#c0bebe';
export const COLOR_EXTRACTED_VALUES_22 = [199, 219, 76]; // '#c7db4c';
export const COLOR_EXTRACTED_VALUES_23 = [199, 219, 78]; // '#c7db4e';
export const COLOR_EXTRACTED_VALUES_24 = [204, 204, 204]; // '#ccc';
export const COLOR_EXTRACTED_VALUES_25 = [206, 212, 218]; // '#ced4da';
export const COLOR_EXTRACTED_VALUES_26 = [212, 228, 255]; // '#d4e4ff';
export const COLOR_EXTRACTED_VALUES_27 = [216, 216, 216]; // '#d8d8d8';
export const COLOR_EXTRACTED_VALUES_28 = [216, 222, 227]; // '#d8dee3';
export const COLOR_EXTRACTED_VALUES_29 = [218, 218, 218]; // '#dadada';
export const COLOR_EXTRACTED_VALUES_30 = [219, 240, 255]; // '#dbf0ff';
export const COLOR_EXTRACTED_VALUES_31 = [219, 76, 76]; // '#db4c4c';
export const COLOR_EXTRACTED_VALUES_32 = [222, 226, 230]; // '#dee2e6';
export const COLOR_EXTRACTED_VALUES_33 = [223, 223, 223]; // '#dfdfdf';
export const COLOR_EXTRACTED_VALUES_34 = [228, 239, 247]; // '#e4eff7';
export const COLOR_EXTRACTED_VALUES_35 = [229, 86, 86]; // '#e55656';
export const COLOR_EXTRACTED_VALUES_36 = [231, 234, 239]; // '#e7eaef';
export const COLOR_EXTRACTED_VALUES_37 = [234, 234, 234]; // '#eaeaea';
export const COLOR_EXTRACTED_VALUES_38 = [238, 238, 238]; // '#eee';
export const COLOR_EXTRACTED_VALUES_39 = [239, 241, 245]; // '#eff1f5';
export const COLOR_EXTRACTED_VALUES_40 = [240, 240, 240]; // '#f0f0f0';
export const COLOR_EXTRACTED_VALUES_41 = [244, 11, 11]; // '#f40b0b';
export const COLOR_EXTRACTED_VALUES_42 = [245, 245, 245]; // '#f5f5f5';
export const COLOR_EXTRACTED_VALUES_43 = [245, 246, 248]; // '#f5f6f8';
export const COLOR_EXTRACTED_VALUES_44 = [245, 247, 250]; // '#f5f7fa';
export const COLOR_EXTRACTED_VALUES_45 = [246, 205, 210]; // '#f6cdd2';
export const COLOR_EXTRACTED_VALUES_46 = [246, 247, 249]; // '#f6f7f9';
export const COLOR_EXTRACTED_VALUES_47 = [247, 234, 52]; // '#f7ea34';
export const COLOR_EXTRACTED_VALUES_48 = [247, 248, 250]; // '#f7f8fa';
export const COLOR_EXTRACTED_VALUES_49 = [250, 250, 250]; // '#fafafa';
export const COLOR_EXTRACTED_VALUES_50 = [250, 80, 10]; // '#fa500a';
export const COLOR_EXTRACTED_VALUES_51 = [251, 191, 31]; // '#fbbf1f';
export const COLOR_EXTRACTED_VALUES_52 = [252, 190, 3]; // '#fcbe03';
export const COLOR_EXTRACTED_VALUES_53 = [254, 228, 205]; // '#fee4cd';
export const COLOR_EXTRACTED_VALUES_54 = [254, 39, 19]; // '#fe2713';
export const COLOR_EXTRACTED_VALUES_55 = [255, 0, 0]; // '#f00';
export const COLOR_EXTRACTED_VALUES_56 = [255, 148, 9]; // '#ff9409';
export const COLOR_EXTRACTED_VALUES_57 = [255, 253, 179]; // '#fffdb3';
export const COLOR_EXTRACTED_VALUES_58 = [255, 255, 255]; // '#fff';
export const COLOR_EXTRACTED_VALUES_59 = [26, 111, 173]; // '#1a6fad';
export const COLOR_EXTRACTED_VALUES_60 = [27, 157, 44]; // '#1b9d2c';
export const COLOR_EXTRACTED_VALUES_61 = [30, 130, 204]; // '#1e82cc';
export const COLOR_EXTRACTED_VALUES_62 = [30, 144, 30]; // '#1e901e';
export const COLOR_EXTRACTED_VALUES_63 = [31, 68, 97]; // '#1f4461';
export const COLOR_EXTRACTED_VALUES_64 = [3, 227, 252]; // '#03e3fc';
export const COLOR_EXTRACTED_VALUES_65 = [33, 150, 243]; // '#2196f3';
export const COLOR_EXTRACTED_VALUES_66 = [3, 31, 52]; // '#031f34';
export const COLOR_EXTRACTED_VALUES_67 = [34, 119, 255]; // '#27f';
export const COLOR_EXTRACTED_VALUES_68 = [38, 87, 133]; // '#265785';
export const COLOR_EXTRACTED_VALUES_69 = [40, 44, 52]; // '#282c34';
export const COLOR_EXTRACTED_VALUES_70 = [42, 185, 52]; // '#2ab934';
export const COLOR_EXTRACTED_VALUES_71 = [48, 127, 243]; // '#307ff3';
export const COLOR_EXTRACTED_VALUES_72 = [51, 51, 51]; // '#333';
export const COLOR_EXTRACTED_VALUES_73 = [5, 30, 52]; // '#051e34';
export const COLOR_EXTRACTED_VALUES_74 = [61, 134, 230]; // '#3d86e6';
export const COLOR_EXTRACTED_VALUES_75 = [72, 87, 99]; // '#485763';
export const COLOR_EXTRACTED_VALUES_76 = [73, 80, 87]; // '#495057';
export const COLOR_EXTRACTED_VALUES_77 = [75, 163, 229]; // '#4ba3e5';
export const COLOR_EXTRACTED_VALUES_78 = [76, 77, 77]; // '#4c4d4d';
export const COLOR_EXTRACTED_VALUES_79 = [85, 26, 139]; // '#551a8b';
export const COLOR_EXTRACTED_VALUES_80 = [85, 85, 85]; // '#555';
export const COLOR_EXTRACTED_VALUES_81 = [87, 148, 204]; // '#5794cc';
export const COLOR_EXTRACTED_VALUES_82 = [89, 133, 20]; // '#598514';
export const COLOR_EXTRACTED_VALUES_83 = [89, 90, 90]; // '#595a5a';
export const COLOR_EXTRACTED_VALUES_84 = [97, 218, 251]; // '#61dafb';
export const COLOR_EXTRACTED_VALUES_85 = [34, 119, 255]; // '#2277ff';
export const COLOR_EXTRACTED_VALUES_86 = [30, 144, 255];
export const COLOR_EXTRACTED_VALUES_87 = [255, 0, 0];
export const COLOR_EXTRACTED_VALUES_88 = [137, 195, 252];
export const COLOR_EXTRACTED_VALUES_89 = [100, 100, 100];
export const COLOR_EXTRACTED_VALUES_90 = [226, 231, 237];
export const COLOR_EXTRACTED_VALUES_91 = [128, 141, 150];


export const COLOR_EXTRACTED_0 = 'rgb(0, 0, 0)'; // '#000';
export const COLOR_EXTRACTED_1 = 'rgb(0, 0, 153)'; // '#009';
export const COLOR_EXTRACTED_2 = 'rgb(0, 0, 238)'; // '#00e';
export const COLOR_EXTRACTED_3 = 'rgb(0, 112, 243)'; // '#0070f3';
export const COLOR_EXTRACTED_4 = 'rgb(0, 73, 120)'; // '#004978';
export const COLOR_EXTRACTED_5 = 'rgb(102, 102, 102)'; // '#666';
export const COLOR_EXTRACTED_6 = 'rgb(105, 32, 125)'; // '#69207d';
export const COLOR_EXTRACTED_7 = 'rgb(108, 117, 125)'; // '#6c757d';
export const COLOR_EXTRACTED_8 = 'rgb(133, 100, 4)'; // '#856404';
export const COLOR_EXTRACTED_9 = 'rgb(133, 92, 20)'; // '#855c14';
export const COLOR_EXTRACTED_10 = 'rgb(140, 3, 252)'; // '#8c03fc';
export const COLOR_EXTRACTED_11 = 'rgb(141, 158, 168)'; // '#8d9ea8';
export const COLOR_EXTRACTED_12 = 'rgb(148, 207, 88)'; // '#94cf58';
export const COLOR_EXTRACTED_13 = 'rgb(151, 233, 236)'; // '#97e9ec';
export const COLOR_EXTRACTED_14 = 'rgb(160, 160, 160)'; // '#a0a0a0';
export const COLOR_EXTRACTED_15 = 'rgb(179, 197, 68)'; // '#b3c544';
export const COLOR_EXTRACTED_16 = 'rgb(180, 76, 76)'; // '#b44c4c';
export const COLOR_EXTRACTED_17 = 'rgb(182, 82, 0)'; // '#b65200';
export const COLOR_EXTRACTED_18 = 'rgb(188, 243, 57)'; // '#bcf339';
export const COLOR_EXTRACTED_19 = 'rgb(189, 156, 25)'; // '#bd9c19';
export const COLOR_EXTRACTED_20 = 'rgb(190, 86, 86)'; // '#be5656';
export const COLOR_EXTRACTED_21 = 'rgb(192, 190, 190)'; // '#c0bebe';
export const COLOR_EXTRACTED_22 = 'rgb(199, 219, 76)'; // '#c7db4c';
export const COLOR_EXTRACTED_23 = 'rgb(199, 219, 78)'; // '#c7db4e';
export const COLOR_EXTRACTED_24 = 'rgb(204, 204, 204)'; // '#ccc';
export const COLOR_EXTRACTED_25 = 'rgb(206, 212, 218)'; // '#ced4da';
export const COLOR_EXTRACTED_26 = 'rgb(212, 228, 255)'; // '#d4e4ff';
export const COLOR_EXTRACTED_27 = 'rgb(216, 216, 216)'; // '#d8d8d8';
export const COLOR_EXTRACTED_28 = 'rgb(216, 222, 227)'; // '#d8dee3';
export const COLOR_EXTRACTED_29 = 'rgb(218, 218, 218)'; // '#dadada';
export const COLOR_EXTRACTED_30 = 'rgb(219, 240, 255)'; // '#dbf0ff';
export const COLOR_EXTRACTED_31 = 'rgb(219, 76, 76)'; // '#db4c4c';
export const COLOR_EXTRACTED_32 = 'rgb(222, 226, 230)'; // '#dee2e6';
export const COLOR_EXTRACTED_33 = 'rgb(223, 223, 223)'; // '#dfdfdf';
export const COLOR_EXTRACTED_34 = 'rgb(228, 239, 247)'; // '#e4eff7';
export const COLOR_EXTRACTED_35 = 'rgb(229, 86, 86)'; // '#e55656';
export const COLOR_EXTRACTED_36 = 'rgb(231, 234, 239)'; // '#e7eaef';
export const COLOR_EXTRACTED_37 = 'rgb(234, 234, 234)'; // '#eaeaea';
export const COLOR_EXTRACTED_38 = 'rgb(238, 238, 238)'; // '#eee';
export const COLOR_EXTRACTED_39 = 'rgb(239, 241, 245)'; // '#eff1f5';
export const COLOR_EXTRACTED_40 = 'rgb(240, 240, 240)'; // '#f0f0f0';
export const COLOR_EXTRACTED_41 = 'rgb(244, 11, 11)'; // '#f40b0b';
export const COLOR_EXTRACTED_42 = 'rgb(245, 245, 245)'; // '#f5f5f5';
export const COLOR_EXTRACTED_43 = 'rgb(245, 246, 248)'; // '#f5f6f8';
export const COLOR_EXTRACTED_44 = 'rgb(245, 247, 250)'; // '#f5f7fa';
export const COLOR_EXTRACTED_45 = 'rgb(246, 205, 210)'; // '#f6cdd2';
export const COLOR_EXTRACTED_46 = 'rgb(246, 247, 249)'; // '#f6f7f9';
export const COLOR_EXTRACTED_47 = 'rgb(247, 234, 52)'; // '#f7ea34';
export const COLOR_EXTRACTED_48 = 'rgb(247, 248, 250)'; // '#f7f8fa';
export const COLOR_EXTRACTED_49 = 'rgb(250, 250, 250)'; // '#fafafa';
export const COLOR_EXTRACTED_50 = 'rgb(250, 80, 10)'; // '#fa500a';
export const COLOR_EXTRACTED_51 = 'rgb(251, 191, 31)'; // '#fbbf1f';
export const COLOR_EXTRACTED_52 = 'rgb(252, 190, 3)'; // '#fcbe03';
export const COLOR_EXTRACTED_53 = 'rgb(254, 228, 205)'; // '#fee4cd';
export const COLOR_EXTRACTED_54 = 'rgb(254, 39, 19)'; // '#fe2713';
export const COLOR_EXTRACTED_55 = 'rgb(255, 0, 0)'; // '#f00';
export const COLOR_EXTRACTED_56 = 'rgb(255, 148, 9)'; // '#ff9409';
export const COLOR_EXTRACTED_57 = 'rgb(255, 253, 179)'; // '#fffdb3';
export const COLOR_EXTRACTED_58 = 'rgb(255, 255, 255)'; // '#fff';
export const COLOR_EXTRACTED_59 = 'rgb(26, 111, 173)'; // '#1a6fad';
export const COLOR_EXTRACTED_60 = 'rgb(27, 157, 44)'; // '#1b9d2c';
export const COLOR_EXTRACTED_61 = 'rgb(30, 130, 204)'; // '#1e82cc';
export const COLOR_EXTRACTED_62 = 'rgb(30, 144, 30)'; // '#1e901e';
export const COLOR_EXTRACTED_63 = 'rgb(31, 68, 97)'; // '#1f4461';
export const COLOR_EXTRACTED_64 = 'rgb(3, 227, 252)'; // '#03e3fc';
export const COLOR_EXTRACTED_65 = 'rgb(33, 150, 243)'; // '#2196f3';
export const COLOR_EXTRACTED_66 = 'rgb(3, 31, 52)'; // '#031f34';
export const COLOR_EXTRACTED_67 = 'rgb(34, 119, 255)'; // '#27f';
export const COLOR_EXTRACTED_68 = 'rgb(38, 87, 133)'; // '#265785';
export const COLOR_EXTRACTED_69 = 'rgb(40, 44, 52)'; // '#282c34';
export const COLOR_EXTRACTED_70 = 'rgb(42, 185, 52)'; // '#2ab934';
export const COLOR_EXTRACTED_71 = 'rgb(48, 127, 243)'; // '#307ff3';
export const COLOR_EXTRACTED_72 = 'rgb(51, 51, 51)'; // '#333';
export const COLOR_EXTRACTED_73 = 'rgb(5, 30, 52)'; // '#051e34';
export const COLOR_EXTRACTED_74 = 'rgb(61, 134, 230)'; // '#3d86e6';
export const COLOR_EXTRACTED_75 = 'rgb(72, 87, 99)'; // '#485763';
export const COLOR_EXTRACTED_76 = 'rgb(73, 80, 87)'; // '#495057';
export const COLOR_EXTRACTED_77 = 'rgb(75, 163, 229)'; // '#4ba3e5';
export const COLOR_EXTRACTED_78 = 'rgb(76, 77, 77)'; // '#4c4d4d';
export const COLOR_EXTRACTED_79 = 'rgb(85, 26, 139)'; // '#551a8b';
export const COLOR_EXTRACTED_80 = 'rgb(85, 85, 85)'; // '#555';
export const COLOR_EXTRACTED_81 = 'rgb(87, 148, 204)'; // '#5794cc';
export const COLOR_EXTRACTED_82 = 'rgb(89, 133, 20)'; // '#598514';
export const COLOR_EXTRACTED_83 = 'rgb(89, 90, 90)'; // '#595a5a';
export const COLOR_EXTRACTED_84 = 'rgb(97, 218, 251)'; // '#61dafb';
export const COLOR_EXTRACTED_85 = 'rgb(34, 119, 255)'; // '#2277ff';
export const COLOR_EXTRACTED_86 = 'rgb(30, 144, 255)';
export const COLOR_EXTRACTED_87 = 'rgb(255, 0, 0)';
export const COLOR_EXTRACTED_88 = 'rgb(137, 195, 252)';
export const COLOR_EXTRACTED_89 = 'rgb(100, 100, 100)';
export const COLOR_EXTRACTED_90 = 'rgb(226, 231, 237)';
export const COLOR_EXTRACTED_91 = 'rgb(128, 141, 150)';

export const SCORE_COLORS = [
  COLOR_EXTRACTED_85,
  COLOR_EXTRACTED_71,
  COLOR_EXTRACTED_74,
  COLOR_EXTRACTED_81,
  COLOR_EXTRACTED_47,
  COLOR_EXTRACTED_51,
  COLOR_EXTRACTED_56,
  COLOR_EXTRACTED_50,
  COLOR_EXTRACTED_41,
] as const;

export const SEMI_ACCESSIBLE_SCORE_COLORS = [
  COLOR_EXTRACTED_85,
  COLOR_EXTRACTED_81,
  COLOR_EXTRACTED_19,
  COLOR_EXTRACTED_17,
  COLOR_EXTRACTED_41,
] as const;
